import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { LineReveal } from "@/components/LineReveal";
import { Countdown } from "@/components/Countdown";
import { Footer } from "@/components/Footer";

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api
      .get("/products")
      .then(({ data }) => setProducts(data))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  return (
    <main data-testid="shop-page" className="bg-white text-black min-h-screen">
      <div className="pt-36 md:pt-48 pb-24 px-6 md:px-12">
        <p className="text-[10px] tracking-[0.35em] uppercase text-black/40 mb-6">Drop 001 — Six Pieces</p>
        <LineReveal
          immediate
          lines={["The Shop"]}
          className="font-serif text-6xl md:text-8xl tracking-tight mb-20 md:mb-28"
        />
        <div
          data-testid="shop-drop-strip"
          className="flex flex-col md:flex-row md:items-center md:justify-between gap-8 border-y border-black/10 py-8 mb-20 md:mb-28 -mt-10 md:-mt-14"
        >
          <p className="text-[10px] tracking-[0.35em] uppercase text-black/40">
            15% off every tee — ends October 25
          </p>
          <Countdown dark={false} compact />
        </div>
        {loaded && products.length === 0 && (
          <p data-testid="shop-empty" className="font-serif italic text-2xl text-black/40">
            The racks are being restocked.
          </p>
        )}
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {products.map((p, i) => (
            <ProductCard key={p.lookup_key} product={p} index={i} />
          ))}
        </div>
      </div>
      <Footer />
    </main>
  );
}
